import React from 'react';
import './Hotels.css';
import { IoBed } from "react-icons/io5";

const Hotels: React.FC = () => {

  const addresses = [
    'VILLA C BOUTIQUE',
    'HOTEL BRAZÃO',
    'VENCESLAU WINE BOUTIQUE HOTEL',
    'B&B HOTEL VILA DO CONDE'
  ]
  const openMaps = (address: string) => {
    console.log(address)
    const encodedAddress = encodeURIComponent(address);
    const mapsUrl = `https://www.google.com/maps?q=${encodedAddress}`;
    window.open(mapsUrl, '_blank');
  };

  return (
    <div className="hotels-container">
      <h2 className="hotels-header">Onde Ficar?</h2>
      <div className="hotels-content">
        <div className="hotels-list">
            <div className="hotels-icon">
                <IoBed />
            </div>
            <span onClick={() => openMaps(addresses[0])}>
                <p className='hotel-address'>VILLA C BOUTIQUE HOTEL</p>
                <p className='hotel-distance'>7.9 KMS</p>
            </span>
            <span onClick={() => openMaps (addresses[1])}>
                <p className='hotel-address'>HOTEL BRAZÃO</p>
                <p className='hotel-distance'>8.4 KMS</p>
            </span>
            <span onClick={() => openMaps (addresses[2])}>
                <p className='hotel-address'>VENCESLAU WINE BOUTIQUE HOTEL</p>
                <p className='hotel-distance'>9.6 KMS</p>
            </span>
            <span onClick={() => openMaps (addresses[3])}>
                <p className='hotel-address'>B&B HOTEL VILA DO CONDE</p>
                <p className='hotel-distance'>11.6 KMS</p>
            </span>
        </div>
        <div className="hotels-image">
          <img src="/hotel_image.jpg" alt="Hotels" />
        </div>
      </div>
    </div>
  );
};

export default Hotels;